// extracted by mini-css-extract-plugin
export var statItem = "_f4-1";
export var statsRow = "_f4-0";